/* eslint-disable @typescript-eslint/no-explicit-any */
import { PrivateLayoutProps } from '@typing/global';
import { Spin } from 'antd';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { Navigate, useLocation, useNavigate } from 'react-router-dom';
// @ts-ignore
import { getAccessToken } from '../auth';
import whiteLogo from '../images/logo/whitelogo.png';
import authIcon from '../images/brand/authicons.png';

export const PrivateLayout: React.FC<PrivateLayoutProps> = ({ children }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const isLoading = useSelector((state: any) => state?.General?.loading);
    const user = useSelector((state: any) => state?.Auth);
    let userData = user?.user?.data || user?.user?.user;

    const routes = ['/login', '/register'];
    let isLoggedin = getAccessToken();

    const checkLogin =()=> {
        if (!userData?.isPasswordChanged) {
            if(location.pathname !== '/account') {
                return navigate('/dashboard', { replace: true });
            }
        }
        if (userData?.isPasswordChanged && !userData?.isSetupCompleted) {
            if(location.pathname !== '/setup') {
                return navigate('/dashboard', { replace: true });
            }
        }
        // return  navigate('/dashboard', { replace: true }); //<Navigate to="/dashboard" replace />
    }

    useEffect(()=> {
        if (isLoggedin && routes.includes(location.pathname)) {
            checkLogin()
        }
    }, [location.pathname])

    return (
        <div className="privateWrapper d-flex align-items-center justify-content-center">
            {isLoading ? (
                <Spin fullscreen tip="Loading..."></Spin>) :
                <div className="cardWhite">
                    <div className="row">
                        <div className="col-lg-6 col-sm-12">
                            <div className="sidebanner">
                                <div className="mainLogsContined">
                                    <div className="whitelogos">
                                        <img src={whiteLogo} alt="logo" />
                                    </div>
                                </div>

                                <div className="majoricons">
                                    <img src={authIcon} alt="bannerImg" />
                                </div>

                                <div className="authSidetext">
                                    <h5>
                                        Get your happy clients referring you with
                                        ReferUS.{' '}
                                    </h5>
                                    <p>
                                        When it comes to marketing your business
                                        there's no one better than a happy customer
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-sm-12">
                            {children}
                        </div>
                    </div>
                </div>
            }
        </div>
    );
};
